export default function changeFavicon() {
    const favicon32 = document.getElementById('favicon-32')
    const favicon16 = document.getElementById('favicon-16')
    const metaImage = document.getElementById('meta-image')
    const appleTouch = document.getElementById('apple-touch')
    const shortcutIcon = document.getElementById('shortcut-icon')
    favicon32.href = '/res/favicon-red-32x32.png'
    metaImage.content = '/res/favicon-red-32x32.png'
    appleTouch.href = '/res/apple-icon-red.png'
    favicon16.href = '/res/favicon-red-16x16.png'
    shortcutIcon.href = '/res/favicon-red-32x32.png'
}